module.exports = __webpack_public_path__ + "img/product.7ea7009a.svg";